import { ForwardedRef, forwardRef } from 'react';

export const IconHome = forwardRef(
  (
    {
      filled,
      ...props
    }: React.SVGProps<SVGSVGElement> & { readonly filled?: boolean },
    ref: ForwardedRef<SVGSVGElement>,
  ) => {
    return (
      <svg
        ref={ref}
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        {filled ? (
          <path
            fill="currentColor"
            d="M4 21V9l8.05-6L20 9v12h-5.85v-7.125H9.825V21H4z"
          ></path>
        ) : (
          <path
            fill="currentColor"
            d="M4 21V9l8.05-6L20 9v12h-5.85v-7.125H9.825V21H4zm1.5-1.5h2.825v-7.125h7.325V19.5h2.85V9.75l-6.45-4.875L5.5 9.75v9.75z"
          ></path>
        )}
      </svg>
    );
  },
);

IconHome.displayName = 'IconHome';

export default IconHome;
